import { render, staticRenderFns } from "./DRHDepotPiece.vue?vue&type=template&id=7ccee844&"
import script from "./DRHDepotPiece.vue?vue&type=script&lang=js&"
export * from "./DRHDepotPiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports